import { Page, Text, View, Document, StyleSheet, Font, Image } from "@react-pdf/renderer";
import img1 from "../../statics/img/01.png";
import i_ac from "../../statics/img/certificates/AC.png";
import i_ec from "../../statics/img/certificates/EC.png";
import i_ic from "../../statics/img/certificates/IC.png";

Font.register({
  family: "BIZ-UDMinchoM",
  fonts: [
    {
      src: "../fonts/BIZ-UDMinchoM001.ttf",
    },
    {
      src: "../fonts/CENTURY.ttf",
      fontWeight: "bold",
    },
  ],
});

const styles = StyleSheet.create({
  page: {
    padding: 2,
    fontSize: 20,
    fontFamily: "BIZ-UDMinchoM",
    width: '2480px',
    height: '1800px'
  },
  section: {
    margin: 0,
    padding: 5,
    flexGrow: 1,
  },
});

const Certificate1PDF = ({title, category}: {title: string | undefined, category: number | null}) => {
  const userName = sessionStorage.getItem('userName');
  const date = new Date().toLocaleDateString().replaceAll('/','.')
  const image = category === 1 ? i_ic : category === 2 ? i_ac : i_ec;
  return (
    <Document>
      <Page orientation="landscape" style={styles.page}>
        <View style={styles.section}>
          <Image src={image} />
        </View>
        <View style={styles.section}>
          <div style={{alignItems: "center"}}>
            <Text style={{fontSize: "40px"}}>{userName}</Text>
            <Text style={{marginTop:15}}>{title || ''}</Text>
            <Text style={{marginTop:15, fontWeight: 'bold'}}>{date}</Text>
            <Text style={{marginTop:15, fontWeight: 'bold'}}>Growzeal Inc</Text>
          </div>
        </View>
      </Page>
    </Document>
  );
}

export default Certificate1PDF;